var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_3243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.501 12.6901V14.9401C16.5019 15.1489 16.4591 15.3557 16.3754 15.5471C16.2918 15.7385 16.169 15.9103 16.0151 16.0515C15.8612 16.1927 15.6795 16.3002 15.4816 16.3671C15.2837 16.434 15.0741 16.4589 14.866 16.4401C12.5582 16.1893 10.3413 15.4007 8.39355 14.1376C6.58142 12.9861 5.04505 11.4497 3.89355 9.63757C2.62603 7.68098 1.83723 5.45332 1.59105 3.13507C1.57231 2.92767 1.59695 2.71864 1.66342 2.52129C1.72989 2.32394 1.83673 2.14259 1.97712 1.98879C2.11752 1.83499 2.2884 1.7121 2.47889 1.62796C2.66938 1.54382 2.8753 1.50027 3.08355 1.50007H5.33355C5.69753 1.49649 6.05039 1.62538 6.32637 1.86272C6.60235 2.10006 6.78261 2.42966 6.83355 2.79007C6.92852 3.51012 7.10464 4.21712 7.35855 4.89757C7.45946 5.16602 7.4813 5.45776 7.42148 5.73823C7.36166 6.01871 7.2227 6.27616 7.02105 6.48007L6.06855 7.43257C7.13622 9.31023 8.69089 10.8649 10.5685 11.9326L11.521 10.9801C11.725 10.7784 11.9824 10.6395 12.2629 10.5796C12.5434 10.5198 12.8351 10.5417 13.1035 10.6426C13.784 10.8965 14.491 11.0726 15.211 11.1676C15.5754 11.219 15.9081 11.4025 16.1459 11.6832C16.3838 11.9639 16.5102 12.3223 16.501 12.6901Z",
    stroke: "#00ADF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_3243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon1);
export default __webpack_public_path__ + "static/media/phone-icon1.3d390152834baf99b8d68f8688ca3235.svg";
export { ForwardRef as ReactComponent };